import { motion } from 'framer-motion';
import { useState } from 'react';
import { useLocation } from 'react-router';
import DBetGameBlockStats from '../components/DBetGame/DBetGameBlockStats';
import DBetGameCurrentRates from '../components/DBetGame/DBetGameCurrentRates';
import DBetGameEventsLog from '../components/DBetGame/DBetGameEventsLog';
import DBetGameInfoCard from '../components/DBetGame/DBetGameInfoCard';
import DBetGameNavigate from '../components/DBetGame/DBetGameNavigate';
import DBetGameRollArea from '../components/DBetGame/DBetGameRollArea';
import DBetGameTotalPrize from '../components/DBetGame/DBetGameTotalPrize';
import DBetGameUIButton from '../components/DBetGame/DBetGameUIButton';
import DBetTitle from '../components/Graphics/DBetTitle';

interface IDBetEventLog {
  time: number;
  text: string;
}

const sum = (a: number, b: number) => a + b;

const DBetGame = () => {
  // states and contexts
  const location = useLocation();
  const path = location.pathname.split('/')[2];

  // events log
  const [djackEventsLog, setDjackEventsLog] = useState<IDBetEventLog[]>([]);

  // game states input(gameId=activeGameId, userId)
  const [activeGameId] = useState<number>(5);
  const [gameState] = useState<number>(1); // gameState 0: not initiated 1: accepting bets, 2: roll progress, 3: game over
  const [totalBets] = useState<number[]>([
    2.2222, 2.32, 3.65, 2.071, 2.111, 1.55
  ]);
  const [playerBets] = useState<number[]>([0.2222, 0.32, 0.65, 0.071, 0, 0]);
  const [rollBlock] = useState<number>(178562);
  const [rollValue] = useState<number>(0);

  // functions
  // bet(gameId, userId, betValue)
  // collect(gameId)

  return (
    <motion.div
      key="dbetGame"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="card">
        <div className="cardTitle">
          <DBetTitle />
        </div>
        <div className="innerCard">
          <div className="innerCardTitle innerCardTitleWithButton">
            <span>Roll No:</span>
            <span>{`#${path}`}</span>
          </div>
          <div className="dbetGameRollAreaWrapper">
            <DBetGameRollArea
              totalBets={totalBets}
              rollValue={rollValue}
              isFetching={false}
            />
          </div>
        </div>
        <div className="innerCard">
          <div className="innerCardTitle">
            <DBetGameUIButton gameState={gameState} />
          </div>
        </div>
        <div className="innerCard">
          <div className="dbetGameBlockStatsWrapper">
            <DBetGameBlockStats rollBlock={rollBlock} currentBlock={178554} />
          </div>
        </div>
        <div className="innerCard">
          <div className="dbetGameCurrentRatesWrapper">
            <DBetGameCurrentRates
              totalBets={totalBets}
              playerBets={playerBets}
            />
          </div>
        </div>
        <div className="innerCard">
          <DBetGameTotalPrize
            gameBalance={Math.round(totalBets.reduce(sum, 0) * 1000) / 1000}
          />
        </div>
        <div className="innerCard">
          <div className="innerCardTitle">
            <span>Events Log</span>
          </div>
          <DBetGameEventsLog
            djackEventsLog={djackEventsLog}
            setDjackEventsLog={setDjackEventsLog}
          />
        </div>
      </div>
      <DBetGameNavigate activeGameId={activeGameId} />
      <DBetGameInfoCard />
    </motion.div>
  );
};

export default DBetGame;
